"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function () {
    window.CustomEvent =
        window.CustomEvent ||
            function (event, parameters) {
                parameters = parameters || { bubbles: false, cancelable: false, detail: null };
                var customEvent = document.createEvent("CustomEvent");
                customEvent.initCustomEvent(event, parameters.bubbles, parameters.cancelable, parameters.detail);
                return customEvent;
            };
})();
//# sourceMappingURL=custom-event.js.map